import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { InventoryItemsOutput } from "types/web-app";

export const listInventoryItems = async (accessToken: string) => {
  try {
    const response = await fetchWithAuth("/inventory-items", accessToken);

    const data =
      (await response.json()) as ServiceResponse<InventoryItemsOutput>;

    return data;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
